import { render, staticRenderFns } from "./WorkOrderArea.vue?vue&type=template&id=2a38afd4"
import script from "./WorkOrderArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkOrderArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkOrderArea.vue?vue&type=style&index=0&id=2a38afd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports